

import React from "react";
import { Nav, Form, Dropdown , Badge} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import { getCartValue} from "../../src/services/ProductsService";
import Logo from "../assets/trezi-logo.png" ;
import UserImage from "../assets/UserImage.png";
import OrderImage from "../assests/public/Vector (3).png";
import Swal from 'sweetalert2';
import category from "../assets/category.svg";
import cluster from "../assets/cluster.svg";
import attribute from "../assets/attribute.svg";
import inventory from "../assets/inventory.svg";
import fusion from "../assests/public/Group 3225 (1).png";
import generativeai from "../assests/public/creative (1).png";
import help from "../assets/help.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import logoutIcon from "../assests/public/icon_logout.png";
import profileIcon from "../assests/public/icon_profile.png";
import settingIcon from "../assests/public/settings.png";
import subscriptionIcon from "../assests/public/icon_My subscription.png";
import { baseUrlUser } from "../utils/common";
import { ListItemIcon } from "@material-ui/core";
// Header CSS
import "../components/Header/Header.css";

const urlUser = baseUrlUser;

function getCookie(name) {
  const cookies = document.cookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();

    if (cookie.startsWith(`${name}=`)) {
      return cookie.substring(name.length + 1);
    }
  }
}

function withParams(Component) {
  return (props) => <Component {...props} params={useParams()} />;
}

function withNavigation(Component) {
  return (props) => <Component {...props} navigate={useNavigate()} />;
}

class Navbarfinbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      eventKey: "",
      CartData: props.cartData || {},
    };
  }

  componentDidMount() {
    this.updateActiveTab();
    this.fetchAllCartItems();

  }

  componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) {
      this.updateActiveTab();
    }
    if (prevProps.cartData !== this.props.cartData) {
      // Update the state with the new cartData
      this.setState({
        CartData: this.props.cartData,
      });
    }
  }

  // continuouslyFetchCartItems = () => {
  //   this.fetchInterval = setInterval(() => {
  //     this.fetchAllCartItems();
  //   }, 5000);
  // };
  componentWillUnmount() {
    // clearInterval(this.fetchInterval);
  }
  async fetchAllCartItems() {
    try {
      const logs = await getCartValue();
      this.setState({
        CartData: logs.data,
      });
    } catch (err) {
      console.log(err);
    }
  }
  
  updateActiveTab() {
    const { pathname } = window.location;
  
    // Define a mapping between paths and event keys
    const pathEventKeyMap = {
      "/financeportal": "1",
      "/Vendor-Details": "2",
      "/paymentPortal": "3",
      "/clinetUsage": "4",
    };
  
    // Get the eventKey based on the pathname
    const eventKey = pathEventKeyMap[pathname] || "";
  
    // Set the state with the correct eventKey
    this.setState({ eventKey });
  }
  handleLogout = async (e) => {
    e.preventDefault();
    const { navigate } = this.props;
    const treziAccessToken = getCookie("treziAccessToken");
     if (!treziAccessToken) {
      console.error("JWT token or email not found in cookies"); 
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'JWT token or email not found in cookies',
      });
      return;
    }
  
    try {
      const response = await fetch(`${urlUser}users/logout`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Cookie: `treziAccessToken=${treziAccessToken}`,
          Authorization: `Bearer ${treziAccessToken}`,
        },
      });
  
      if (response.ok) {
        document.cookie = "trezi-access=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "orgIdentifier=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "role=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "treziAccessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        localStorage.removeItem("role");
        localStorage.removeItem("treziAccessToken");
        localStorage.removeItem("organizationIdentifier");
        navigate("/");
        console.log("User logged out successfully.");
        // Swal.fire({
        //   icon: 'success',
        //   title: 'Logged Out',
        //   text: 'User logged out successfully.',
        // });
      } else {
        // Logout failed
        console.error("User logout failed");
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'User logout failed , JWT Token expired.',
        });
        window.location.href = "/";
      }
    } catch (error) {
      console.error("An error occurred during user logout:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'An error occurred during user logout',
      });
    }
  };
  
  
  render() {
    const { eventKey  } = this.state;
    const {  CartData } = this.state;
    console.log(CartData);
    return (
      <>
        {[false].map((expand, index) => (
          <React.Fragment key={index}>
            <Navbar
              className="tz-navbar"
              sticky="top"
              key={`navbar-${expand}-${index}`}
              bg="dark"
              variant="dark"
              expand={expand}
            >
              <Container fluid className="tz-toggle">
                <div className="tz-header-left-section">
                  {/* <Navbar.Toggle
                    aria-controls={`offcanvasNavbar-expand-${expand}`}
                    className="tz-toggle-left-menu"
                  /> */}
                  <Navbar.Brand  className="tz-logo-container">
                    <img src={Logo} alt="Logo" />
                    <span>Trezi</span>
                  </Navbar.Brand>
                </div>

             
                < div className="tz-header-right-section d-flex align-items-center " >
                <div className="position-relative">
                  
  </div>
                  < div >
                  <Dropdown >
                  <Dropdown.Toggle className="tz-user-dropdown">
                    <img src={UserImage} alt="User" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="tz-user-menu">
                    <Dropdown.Item className="myprofile-button" href ="/financeProfile">
                    <Link to="/financeProfile" className="dropdown-link">
      <ListItemIcon>
        <img src={profileIcon} alt="Logout" width={20} height={20} />
        <span></span>
        <span className="myprofile-text">My Profile</span>
      </ListItemIcon>
    </Link>
                    </Dropdown.Item>
                    <Dropdown.Item className="logout-button"  onClick={this.handleLogout} href="#">
                      <ListItemIcon>
                        <img
                          src={logoutIcon}
                          alt="Logout"
                          width={20}
                          height={20}
                        />{" "}
                   <span></span>  <span className="logout-text">Logout</span>
                      </ListItemIcon>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                  </div>
  </div>
                

                <Navbar.Offcanvas
                  id={`offcanvasNavbar-expand-${expand}`}
                  aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                  placement="start"
                >
                  <Offcanvas.Body className="tz-toggle-body">
                    <div data-option="inventory" onClick={this.handleClick}>
                      <img src={inventory} alt="Inventory log" />{" "}
                      <span  data-option="inventory">Inventory Log</span> 
                    </div>
                    <div data-option="order-management" onClick={this.handleClick}>
                      <img src={OrderImage} width={15} alt="order-management" />{" "}
                      <span  data-option="order-management">Order Management</span> 
                    </div>
                    <div data-option="product-attributes" onClick={this.handleClick}>
                      <img src={attribute} alt="Product Attributes" />{" "}
                      <span  data-option="product-attributes">Product Attributes</span>
                    </div>
                    <div data-option="product-clusters" onClick={this.handleClick}>
                      <img src={cluster} alt="product-clusters" />{" "}
                      <span data-option="product-clusters">Product Clusters</span>
                    </div>
                    <div   data-option= "Product-categories" onClick={this.handleClick} >
                      <img src={category} alt="Product-categories" />{" "}
                      <span   data-option= "Product-categories" >Product Categories</span>
                    </div>
                    <div data-option="generate-AI"  onClick={this.handleClick}>
                      <img    style={{width :"15px"}}  src={generativeai} alt="Generate-AI" />{" "}
                      <span data-option="generate-AI">Generate AI Image</span>
                    </div>
                    <div data-option="overlay-img"  onClick={this.handleClick}>
                      <img className="fusion-design" src={fusion} alt="overlay-img"  />{" "}
                      <span data-option="overlay-img">Fusion Canvas</span>
                    </div>
                    <div data-option="help"  onClick={this.handleClick}>
                      <img src={help} alt="Help and Support"  />{" "}
                      <span data-option="help">Help & Support</span>
                    </div>
                  </Offcanvas.Body>
                </Navbar.Offcanvas>
              </Container>
            </Navbar>
            <Navbar
              key={`navbar-header-${expand}-${index}`}
              bg="dark"
              variant="dark"
              className="tz-header-navbar"
            >
              <Container fluid>
                <Nav
                  className="d-flex justify-content-center tab tz-header-tabs"
                  key={`${expand}-${index}`}
                  fill
                  variant="tabs"
                  activeKey={eventKey}
                  onSelect={(selectedTab) =>
                    this.setState({ eventKey: selectedTab })
                  }
                >
                      <Nav.Item>
                    <Nav.Link
                      as={Link}
                      eventKey="1"
                      active={eventKey === "1"}
                      to="/financeportal"
                    >
Reconciliation Portal
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      as={Link}
                      eventKey="2"
                      active={eventKey === "2"}
                      to="/Vendor-Details"
                    >
                    My Vendors
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      as={Link}
                      eventKey="3"
                      active={eventKey === "3"}
                      to="/paymentPortal"
                    >
                      Payment Management
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link
                      as={Link}
                      eventKey="4"
                      active={eventKey === "4"}
                      to="/clinetUsage"
                    >
                Client Points Usage
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Container>
            </Navbar>
          </React.Fragment>
        ))}
      </>
    );
  }
}
export default withNavigation(withParams(Navbarfinbox));
